const initializedShareBlocks = new WeakSet();

const getShareBlocks = () => document.querySelectorAll('[data-job-share]');

const closeShareBlock = (block) => {
  const toggle = block.querySelector('[data-job-share-toggle]');

  block.classList.remove('is-open');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
};

const closeOtherShareBlocks = (currentBlock) => {
  getShareBlocks().forEach((block) => {
    if (block !== currentBlock) closeShareBlock(block);
  });
};

const initJobShare = (scope = document) => {
  const shareBlocks = scope.querySelectorAll('[data-job-share]');

  shareBlocks.forEach((block) => {
    if (initializedShareBlocks.has(block)) return;

    const toggle = block.querySelector('[data-job-share-toggle]');
    const dropdown = block.querySelector('[data-job-share-dropdown]');

    if (!toggle || !dropdown) return;

    initializedShareBlocks.add(block);
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', () => {
      const isOpen = block.classList.contains('is-open');

      closeOtherShareBlocks(block);
      block.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    dropdown.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      if (event.target.closest('.article-sec__share-item')) closeShareBlock(block);
    });
  });
};

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Node)) return;

  getShareBlocks().forEach((block) => {
    if (!block.contains(event.target)) closeShareBlock(block);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  getShareBlocks().forEach(closeShareBlock);
});

initJobShare();
window.initJobShare = initJobShare;
